import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { globalHive } from '../../src/modules/hive'
import { syncCalendarEvents } from '../../src/redux/actions/entities'
import { IDB_calendarEventsWrite } from '../IDB/IDB.table.calendarEvent'
import type { Type_ICalendarEvent } from '../Type/Type.hive'
import { User_get } from '../User/User.get'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'

export function Plan_createEvent(
    date: Date,
    locationId: number,
    activityId?: number,
    campaignId?: number
): Type_ICalendarEvent {
    date = moment(date).hour(11).toDate() // react-big-calendar doesnt like 00 dates

    return {
        id: uuidv4(),
        data: {},
        author: User_get().id,
        startDate: date,
        endDate: date,
        recurring: false,
        campaign: campaignId !== -1 ? campaignId : undefined,
        template: activityId,
        location: locationId,
        complete: false,
        createdDate: new Date(),
        meta: {
            new: true,
        },
    }
}

export async function Plan_addEvent(
    logger: ClientLogger,
    date: Date,
    locationId: number,
    activityId?: number,
    campaignId?: number
): Promise<Type_ICalendarEvent> {
    logger.log('adding calendar event', { date, locationId, activityId, campaignId })
    const event = Plan_createEvent(date, locationId, activityId, campaignId)

    await IDB_calendarEventsWrite([event])
    logger.log(`saved calendar event`, { eventId: event.id })

    globalHive.dispatch(syncCalendarEvents())
    logger.log(`requested re-reading calendar events into redux stores`, { eventId: event.id })

    return event
}
